import { render } from "./pictures.vue?vue&type=template&id=48c2d80e"
import script from "./pictures.vue?vue&type=script&lang=js"
export * from "./pictures.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/input-only/pictures.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48c2d80e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48c2d80e', __exports__)) {
    console.log('reload')
    api.reload('48c2d80e', __exports__)
  }
  
  module.hot.accept("./pictures.vue?vue&type=template&id=48c2d80e", () => {
    console.log('re-render')
    api.rerender('48c2d80e', render)
  })

}


export default __exports__